export default __webpack_public_path__ + "static/media/chatton5.fc5b3b7f.jpg";